package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.api.datasource.cv.Reference
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.ReferenceState
import io.horion.cv.styles.ReferenceFieldsRowStyle
import io.horion.cv.styles.ReferenceFormContainerStyle
import io.horion.cv.styles.ReferenceFullWidthFieldStyle
import io.horion.cv.styles.ReferenceHalfWidthFieldStyle
import io.horion.cv.viewModel.CvViewModel

@Composable
fun ReferenceForm(
    index: Int,
    state: ReferenceState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
) {
    fun updateReference() {
        cvViewModel.updateReference(
            index = index,
            ref = Reference(
                name = state.nom,
                enterprise = state.entreprise,
                city = state.ville,
                phone = state.telephone,
                email = state.mail
            )
        )
    }

    Column(
        modifier = ReferenceFormContainerStyle
            .toModifier()
            .styleModifier {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("overflow", "hidden")
            }
    ) {
        TextFormField(
            label = "Nom",
            value = state.nom,
            onValueChange = {
                state.nom = it
                updateReference()
            },
            modifier = ReferenceFullWidthFieldStyle
                .toModifier()
                .styleModifier {
                    property("width", "100%")
                    property("max-width", "100%")
                    property("min-width", "0")
                    property("box-sizing", "border-box")
                }
        )

        Row(
            modifier = ReferenceFieldsRowStyle
                .toModifier()
                .styleModifier {
                    property("width", "100%")
                    property("max-width", "100%")
                    property("min-width", "0")
                    property("box-sizing", "border-box")
                    property("overflow", "visible")
                }
        ) {
            TextFormField(
                label = "Entreprise",
                value = state.entreprise,
                onValueChange = {
                    state.entreprise = it
                    updateReference()
                },
                modifier = ReferenceHalfWidthFieldStyle
                    .toModifier()
                    .styleModifier {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("box-sizing", "border-box")
                    }
            )

            TextFormField(
                label = "Ville",
                value = state.ville,
                onValueChange = {
                    state.ville = it
                    updateReference()
                },
                modifier = ReferenceHalfWidthFieldStyle
                    .toModifier()
                    .styleModifier {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("box-sizing", "border-box")
                    }
            )
        }

        Row(
            modifier = ReferenceFieldsRowStyle
                .toModifier()
                .styleModifier {
                    property("width", "100%")
                    property("max-width", "100%")
                    property("min-width", "0")
                    property("box-sizing", "border-box")
                    property("overflow", "visible")
                }
        ) {
            TextFormField(
                label = "Numéro de téléphone",
                value = state.telephone,
                onValueChange = {
                    state.telephone = it
                    updateReference()
                },
                modifier = ReferenceHalfWidthFieldStyle
                    .toModifier()
                    .styleModifier {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("box-sizing", "border-box")
                    }
            )

            TextFormField(
                label = "Adresse e-mail",
                value = state.mail,
                onValueChange = {
                    state.mail = it
                    updateReference()
                },
                modifier = ReferenceHalfWidthFieldStyle
                    .toModifier()
                    .styleModifier {
                        property("width", "100%")
                        property("max-width", "100%")
                        property("min-width", "0")
                        property("box-sizing", "border-box")
                    }
            )
        }

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}